import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homeAbout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "About me", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://twitter.com/CreativeIKEP",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", { src: "/images/Twitter_Logo_Blue.png" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://github.com/creativeIKEP",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", { src: "/images/GitHub-Mark-Light-120px-plus.png" })
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" More Products ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" More News ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Product = _resolveComponent("Product")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_News = _resolveComponent("News")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.homeAboutMe")), 1)
    ]),
    _createVNode(_component_Product, { displayProductCount: 6 }),
    _createVNode(_component_center, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "moreShow",
          to: _ctx.routerPath('/product')
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }),
    _createVNode(_component_News, {
      title: "News",
      displayNewsCount: 5
    }),
    _createVNode(_component_center, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "moreShow",
          to: _ctx.routerPath('/about') + '#pastNews'
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    })
  ], 64))
}